'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _Modal = require('./Modal');

var _Modal2 = _interopRequireDefault(_Modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * ModalInstaller will setup the modal under <body/>.
 * We use new portal API, which is a new feature after react 16, to append the modal in body
 * refer to: 1. https://reactjs.org/docs/portals.html
 *           2. https://codepen.io/gaearon/pen/yzMaBd
 */
var ModalInstaller = function (_Component) {
  _inherits(ModalInstaller, _Component);

  function ModalInstaller(props) {
    _classCallCheck(this, ModalInstaller);

    var _this = _possibleConstructorReturn(this, (ModalInstaller.__proto__ || Object.getPrototypeOf(ModalInstaller)).call(this, props));

    _this.node = document.createElement('div');
    return _this;
  }

  _createClass(ModalInstaller, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      document.body && document.body.appendChild(this.node);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      document.body && document.body.removeChild(this.node);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          onCancel = _props.onCancel,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['onCancel', 'children']);

      return _reactDom2.default.createPortal(_react2.default.createElement(
        _Modal2.default,
        Object.assign({ ref: function ref(_ref) {
            return _this2.modal = _ref;
          }, onCancel: onCancel }, otherProps),
        children
      ), this.node);
    }
  }]);

  return ModalInstaller;
}(_react.Component);

exports.default = ModalInstaller;